import React, { useState, useEffect } from 'react';
import RegistrationContext from './RegistrationContext';
import DeleteFamilyByEmail from '../http/DeleteFamilyByEmail';
import GetFamilyGuid from '../http/GetFamilyGuid';

export const RegistrationContextProvider = ({ children }) => {
  const [registrationData, setRegistrationData] = useState();
  const [guid, setGuid] = useState();

  useEffect(() => {
    const savedUserData = sessionStorage.getItem('user');
    if (savedUserData) {
      const data = JSON.parse(savedUserData);
      setRegistrationData(data);
      async function fetchData() {
        const guid = await GetFamilyGuid(data.email);
        setGuid(guid);
      }
      fetchData();
    }
  }, []);

  const updateRegistrationData = (registrationData) => {
    setRegistrationData(registrationData);
    sessionStorage.setItem('user', JSON.stringify(registrationData));
  };

  const cancelRegistration = async () => {
    try {
      await DeleteFamilyByEmail(registrationData.email);
      setRegistrationData(null);
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('childList');
    } catch (error) {}
  };

  const value = {
    registrationData,
    setRegistrationData,
    guid,
    setGuid,
    updateRegistrationData,
    cancelRegistration,
  };

  return (
    <RegistrationContext.Provider value={value}>
      {children}
    </RegistrationContext.Provider>
  );
};
